import React, { useState } from "react";
import TenantApprovalModal from "../../../common/TenantApprovalModal/TenantApprovalModal.jsx";
import { formatDate } from "../../../utils/formatDate.jsx";

const TenantApprovalsLongCard = (props) => {
  const {
    verifier_id,
    verifier_name,
    created_at,
    org_name,
    email,
    phone_no,
    approval_status,

    // BULK ACTIONS

    // onCheckboxChange,
    // isChecked,
    handleConfirmAction,
    onClick,
    selectedApprovalStatus,
  } = props;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [actionType, setActionType] = useState("");
  const [issuerComments, setIssuerComments] = useState("");

  const handleReject = (event) => {
    event.stopPropagation();
    setActionType("Rejected");
    setIsModalOpen(true);
  };

  const handleAccept = (event) => {
    event.stopPropagation();
    setActionType("Approved");
    setIsModalOpen(true);
  };

  const handleModalConfirm = async () => {
    const success = await handleConfirmAction(
      actionType,
      verifier_id,
      issuerComments
    );

    if (success) {
      setIsModalOpen(false);
      setIssuerComments("");
    }
  };

  const handleCardClick = (event) => {
    event.preventDefault();
    if (onClick) {
      onClick();
    }
  };

  // BULK ACTIONS

  // const handleCheckboxChange = (event) => {
  //   event.stopPropagation();
  //   onCheckboxChange(verifier_id, event.target.checked);
  // };

  const getActionStatus = () => {
    const status = approval_status || selectedApprovalStatus;

    if (status === "Approved") {
      return (
        <p className="font-semibold" style={{ color: "#3538CD" }}>
          Approved
        </p>
      );
    }
    if (status === "Rejected") {
      return (
        <p className="font-semibold" style={{ color: "#D94D20" }}>
          Rejected
        </p>
      );
    }

    return (
      <>
        <button
          className="flex rounded-[8px] items-center justify-center gap-2 w-[10rem] h-[2.5rem] lg:w-[10rem] lg:px-0 bg-[#3538CD] text-white font-medium lg:font-semibold text-sm lg:text-md hover:bg-cfPrimaryDark transition duration-200 focus:outline-none"
          onClick={handleAccept}
        >
          <div>Approve</div>
        </button>
        <button
          className="flex rounded-[8px] items-center justify-center gap-2 w-[10rem] h-[2.5rem] lg:w-[10rem] lg:px-0 bg-white text-black font-medium lg:font-semibold text-sm lg:text-md border border-gray-800 hover:bg-gray-100 transition duration-200 focus:outline-none"
          onClick={handleReject}
        >
          <div>Reject</div>
        </button>
      </>
    );
  };

  return (
    <div
      className="flex bg-white items-center min-h-[5rem] border-b py-1 px-4 cursor-pointer "
      onClick={handleCardClick}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handleCardClick(e);
        }
      }}
      role="button"
      tabIndex={0}
    >
      {/* BULK ACTIONS */}
      {/* <div
        className="flex w-[2.0%] justify-center items-center bg-white"
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            e.stopPropagation();
          }
        }}
        role="button"
        tabIndex={0}
      > */}
      {/* {approval_status !== "Approved" && approval_status !== "Rejected" && (
          <input
            type="checkbox"
            checked={isChecked}
            onChange={handleCheckboxChange}
            className="w-5 h-5 border-2 border-gray-500 rounded-lg accent-blue-600 appearance-auto cursor-pointer"
            onClick={(e) => e.stopPropagation()}
          />
        )} */}
      {/* </div> */}
      <div className="flex w-[16.66%] justify-center items-center cursor-pointer ">
        <p className="font-regular text-black text-[14px]">
          {verifier_name || "N/A"}
        </p>
      </div>
      <div className="flex w-[16.66%] justify-center text-center cursor-pointer ">
        <p className="font-regular text-black text-[14px]">
          {org_name || "N/A"}
        </p>
      </div>
      <div className="flex w-[16.66%] justify-center items-center cursor-pointer">
        <p className="font-regular text-black text-[14px]">
          {created_at ? formatDate(created_at) : "No date available"}
        </p>
      </div>
      <div className="flex w-[16.66%] justify-center items-center cursor-pointer">
        <p className="font-regular text-black text-[14px]">{email || "N/A"}</p>
      </div>
      <div className="flex w-[16.66%] justify-center items-center cursor-pointer">
        <p className="font-regular text-black text-[14px]">
          {phone_no || "N/A"}
        </p>
      </div>
      <div className="flex w-[16.66%] justify-center items-center space-x-4">
        {getActionStatus()}
      </div>

      {/* Confirmation Modal */}
      <TenantApprovalModal
        isModalOpen={isModalOpen}
        toggleModal={setIsModalOpen}
        actionType={actionType}
        handleConfirmAction={handleModalConfirm}
        issuerComments={issuerComments}
        setIssuerComments={setIssuerComments}
      />
    </div>
  );
};

export default TenantApprovalsLongCard;
